(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  /* Enforce ONE-OPEN-AT-A-TIME for the FAQ accordion.
     When any <details> in the section opens, close all the others. */
  (function () {
    document.querySelectorAll('.section-faq').forEach((section) => {
      const items = section.querySelectorAll('details.lh-faq__item');
      items.forEach((d) => {
        d.addEventListener('toggle', () => {
          if (!d.open) return;
          items.forEach((other) => {
            if (other !== d && other.open) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-formula"] && !Shopify.designMode) return;
  try {
    
  /* Light parallax for the product image only (discs are static).
     Same scroll-driven pattern as other LEYLY sections. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sections = document.querySelectorAll('.lh-formula');
    if (!sections.length) return;

    const onScreen = new WeakSet();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) onScreen.add(e.target);
        else onScreen.delete(e.target);
      });
    }, { rootMargin: '20% 0px 20% 0px' });
    sections.forEach((s) => io.observe(s));

    let ticking = false;
    function update() {
      const vh = window.innerHeight;
      sections.forEach((sec) => {
        if (!onScreen.has(sec)) return;
        const r = sec.getBoundingClientRect();
        const dist = (vh / 2) - (r.top + r.height / 2);
        sec.querySelectorAll('[data-parallax-speed]').forEach((el) => {
          const speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0;
          el.style.transform = `translate3d(0, ${(dist * speed).toFixed(2)}px, 0)`;
        });
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-ingredients-carousel"] && !Shopify.designMode) return;
  try {
    
  /*
    LEYLY — Key Ingredients Carousel
    --------------------------------------------------------------
    Each item is absolutely positioned inside the viewport. Its X
    offset from center is computed from its "diff" to the active
    index, using the SHORTEST wrap-around path (so items loop
    infinitely both directions). Clicking a side disk makes it
    active; prev/next arrows step ±1 with wraparound.
  */
  (function () {
    document.querySelectorAll('[data-lh-carousel]').forEach((stage) => {
      const items   = stage.querySelectorAll('.lh-ki__item');
      const descs   = stage.querySelectorAll('.lh-ki__desc');
      const prevBtn = stage.querySelector('[data-carousel-prev]');
      const nextBtn = stage.querySelector('[data-carousel-next]');
      if (items.length === 0) return;

      const count = items.length;
      let idx = 0;

      function px(varName, fallback) {
        const v = getComputedStyle(stage).getPropertyValue(varName).trim();
        const n = parseFloat(v);
        return isNaN(n) ? fallback : n;
      }

      function visualX(diff) {
        if (diff === 0) return 0;
        const sideSize   = px('--lh-disk-side', 152);
        const activeSize = px('--lh-disk-active', 300);
        const gap        = px('--lh-disk-gap', 24);
        // Distance from active center to the FIRST neighbor's center
        const firstStep = (activeSize + sideSize) / 2 + gap;
        // Distance between any two adjacent SIDE disks' centers
        const sideStep  = sideSize + gap;
        const sign = Math.sign(diff);
        return sign * (firstStep + (Math.abs(diff) - 1) * sideStep);
      }

      function update() {
        items.forEach((item, i) => {
          let diff = i - idx;
          // Take the SHORT wrap-around path so far-side items appear
          // from the opposite side and never trail across the viewport.
          if (diff >   count / 2) diff -= count;
          if (diff <= -count / 2) diff += count;
          item.style.setProperty('--lh-visual-x', visualX(diff).toFixed(2) + 'px');
          item.classList.toggle('is-active', i === idx);
        });
        descs.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }

      function go(newIdx) {
        idx = ((newIdx % count) + count) % count;
        update();
      }

      // Click on any disk → make it active
      items.forEach((item) => {
        const btn = item.querySelector('[data-carousel-goto]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const target = parseInt(btn.getAttribute('data-carousel-goto'), 10);
          if (!isNaN(target)) go(target);
        });
      });

      // Prev / Next with wraparound
      prevBtn && prevBtn.addEventListener('click', () => go(idx - 1));
      nextBtn && nextBtn.addEventListener('click', () => go(idx + 1));

      // Keyboard arrows when focused on stage
      stage.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  go(idx - 1);
        if (e.key === 'ArrowRight') go(idx + 1);
      });

      // Recompute on resize (the CSS variable values for disk sizes
      // can change at breakpoints).
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(update, 80);
      }, { passive: true });

      // Initial paint after layout settles
      requestAnimationFrame(update);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leyly-footer"] && !Shopify.designMode) return;
  try {
    
  /* LEYLY Footer — scroll-driven parallax on the dot clusters.
     Same pattern as parallax-content. Each dot element has
     data-parallax-speed; red + white pairs share the same speed so
     they stay perfectly aligned under the dome mask. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sections = document.querySelectorAll('[data-lh-footer-parallax]');
    if (!sections.length) return;

    const onScreen = new WeakSet();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) onScreen.add(e.target);
        else onScreen.delete(e.target);
      });
    }, { rootMargin: '20% 0px 20% 0px' });
    sections.forEach((s) => io.observe(s));

    let ticking = false;
    function update() {
      const vh = window.innerHeight;
      sections.forEach((sec) => {
        if (!onScreen.has(sec)) return;
        const r = sec.getBoundingClientRect();
        const dist = (vh / 2) - (r.top + r.height / 2);
        sec.querySelectorAll('[data-parallax-speed]').forEach((el) => {
          const speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0;
          el.style.transform = `translate3d(0, ${(dist * speed).toFixed(2)}px, 0)`;
        });
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-content"] && !Shopify.designMode) return;
  try {
    
  /*
    LEYLY Parallax Content — scroll-driven transform parallax.
  */
  (function () {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const sections = document.querySelectorAll('[data-lh-parallax]');
    if (!sections.length) return;

    const onScreen = new WeakSet();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) onScreen.add(entry.target);
        else onScreen.delete(entry.target);
      });
    }, { rootMargin: '20% 0px 20% 0px' });

    sections.forEach((sec) => io.observe(sec));

    let ticking = false;
    function update() {
      const vh = window.innerHeight;
      sections.forEach((sec) => {
        if (!onScreen.has(sec)) return;
        const secRect = sec.getBoundingClientRect();
        const sectionMid = secRect.top + secRect.height / 2;
        const distFromCenter = (vh / 2) - sectionMid;

        sec.querySelectorAll('[data-parallax-speed]').forEach((el) => {
          const speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0;
          const offset = distFromCenter * speed;
          el.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
        });
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-lh-carousel]').forEach((root) => {
      const slides = root.querySelectorAll('.lh-prod__slide');
      const dots   = root.querySelectorAll('[data-carousel-goto]');
      const prev   = root.querySelector('[data-carousel-prev]');
      const next   = root.querySelector('[data-carousel-next]');
      if (slides.length < 2) return;

      let idx = 0;
      function go(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach((sl, k) => sl.classList.toggle('is-active', k === idx));
        dots.forEach((d, k)   => d.classList.toggle('is-active',   k === idx));
      }
      prev && prev.addEventListener('click', () => go(idx - 1));
      next && next.addEventListener('click', () => go(idx + 1));
      dots.forEach((d) => {
        d.addEventListener('click', () => {
          const target = parseInt(d.getAttribute('data-carousel-goto'), 10);
          if (!isNaN(target)) go(target);
        });
      });

      // Optional: arrow keys when carousel container is focused
      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  go(idx - 1);
        if (e.key === 'ArrowRight') go(idx + 1);
      });
    });

    // Quantity steppers
    document.querySelectorAll('[data-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
        const input = btn.closest('.lh-prod__qty').querySelector('input[type="number"]');
        if (!input || input.disabled) return;
        const current = parseInt(input.value, 10) || 1;
        const min = parseInt(input.getAttribute('min'), 10) || 1;
        input.value = Math.max(min, current + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
